import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import Link from "@components/anti/Link"
import { linkProductsServices } from "src/helper/page-url"
import { useGeneralStore } from "store"

export function ProductMenu({ open, setOpen }) {
  const Router = useRouter()

  const { navbarData } = useGeneralStore()
  const [selectedMenu, setSelectedMenu] = useState({
    active: "",
    list: [],
  })

  useEffect(() => {
    if (!open) {
      setSelectedMenu({
        active: "",
        list: [],
      })
    }
  }, [open])

  useEffect(() => {
    if (open) setOpen(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Router.asPath])
  return (
    <div className={`mega-menu py-5 ${open ? "" : "hide"}`}>
      <div className="menu-gradient" />
      <div className="menu-header pb-4">
        <div className="container">
          <h2 className="menu-title">
            <Link href={linkProductsServices} withArrow>
              {Router.locale === "en"
                ? "Products & Services"
                : "Produk & Layanan"}
            </Link>
          </h2>
        </div>
      </div>
      <div className="menu-line" />
      <div className="menu-body pt-4">
        <div className="container">
          <div className="row row-2 w-100">
            <div className="col-4">
              <ul className="menu-list">
                {navbarData?.map((item, i) => (
                  <li
                    className={`h4 menu-item ${
                      item.slug === selectedMenu.active ? "active" : ""
                    }`}
                    onMouseEnter={() =>
                      item.list
                        ? setSelectedMenu({
                            active: item.slug,
                            list: item.list,
                          })
                        : setSelectedMenu({ active: "", list: [] })
                    }
                    onClick={() => {
                      if (!item.list) {
                        Router.push(item.slug)
                        setOpen(false)
                      }
                    }}
                    key={i}
                    role="presentation"
                  >
                    <div className="item-wrapper">
                      <span className="item-title">{item.title}</span>
                      <div
                        className={`line ${
                          item.slug === selectedMenu.active ? "active" : ""
                        }`}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-8">
              <ul className="menu-list sub">
                {selectedMenu?.list?.map((item, i) => (
                  <li
                    className={`h5 menu-item fadeInRight d${i + 1}`}
                    key={`${i}-${item.title}`}
                  >
                    <Link href={item.slug}>{item.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
